import { message } from "antd";
import useRequest from "./useRequest";
import { useState } from "react";

const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState({
    get: false,
    post: false,
    put: false,
    delete: false,
  });

  const { request } = useRequest();

  async function getUsers(params = {}) {
    const data = await request(
      "GET",
      `users/`,
      (data) => {
        setUsers(data.results);
        return data;
      },
      (error) => {
        return error;
      },
      {},
      params
    );
    return data;
  }

  async function createCoordinator(body) {
    setLoading((prev) => ({ ...prev, post: true }));

    const data = await request(
      "POST",
      `users/register/`,
      (data) => {
        setLoading((prev) => ({ ...prev, post: false }));
        message.success("Coordinator created successfully");
        return data;
      },
      (error) => {
        message.error("Error creando el coordinador");
        setLoading((prev) => ({ ...prev, post: false }));
        return error;
      },
      body
    );

    return data;
  }

  async function getUserDetail(userId) {
    const data = await request(
      "GET",
      `users/${userId}`,
      (data) => {
        return data;
      },
      (error) => {
        return error;
      },
      {}
    );
    return data;
  }

  return {
    getUsers,
    users,
    setUsers,
    loading,
    createCoordinator,
    getUserDetail,
  };
};

export default useUsers;
